import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from '../../Utils/reactIntlCompat';
import { useFormContext } from 'react-hook-form';
import {
  FormControlLabel,
  Checkbox,
  FormControl,
  FormHelperText,
} from '@mui/material';

const FormCheckbox = function FormCheckbox({
  name,
  intl,
  required = false,
  disabled = false,
  error = null,
  hideHelperText = false,
  defaultChecked = false,
  onChange,
}) {
  const { register, getValues, clearErrors, watch } = useFormContext();
  const [value, setValue] = useState(getValues(name) ?? defaultChecked);
  const watcher = watch(name);
  const { message = null } = error || {};
  const nameTranslation = Object.prototype.hasOwnProperty.call(
    intl.messages,
    name?.toUpperCase()
  )
    ? intl.messages[name.toUpperCase()]
    : null;

  useEffect(() => {
    clearErrors(name);
  }, [watcher]);

  useEffect(() => {
    setValue(defaultChecked);
  }, [defaultChecked]);

  return (
    <FormControl error={error}>
      <FormControlLabel
        id={`${name}-checkbox`}
        required={required}
        control={
          <Checkbox
            {...register(name, {
              required: {
                value: required,
                message: intl.messages.MANDATORY_FIELD,
              },
            })}
            checked={value}
            onChange={(event) => {
              setValue(event.target.checked);
              if (onChange) onChange(event.target.checked);
            }}
            // defaultChecked={getValues(name)}
          />
        }
        label={nameTranslation}
        disabled={disabled}
        componentsProps={{
          typography: {
            noWrap: true,
          },
        }}
      />
      {!hideHelperText && (
        <FormHelperText
          sx={{
            whiteSpace: 'noWrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {message || ' '}
        </FormHelperText>
      )}
    </FormControl>
  );
};

FormCheckbox.propTypes = {
  intl: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.object,
  hideHelperText: PropTypes.bool,
};

export default injectIntl(FormCheckbox);
